var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/auth-login/components/login-form.tsx";
import React from 'react';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { Button, Form, FormActions, FormGroup, Input, Stack } from 'soapbox/components/ui';
import ConsumersList from './consumers-list';
const messages = defineMessages({
  username: {
    "id": "login.fields.username_label",
    "defaultMessage": "Email or username"
  },
  password: {
    "id": "login.fields.password_placeholder",
    "defaultMessage": "Password"
  }
});

const LoginForm = _ref => {
  let {
    isLoading,
    handleSubmit
  } = _ref;
  const intl = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "pb-4 sm:pb-10 mb-4 border-b border-gray-200 dark:border-gray-800 border-solid -mx-4 sm:-mx-10",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-center font-bold text-2xl",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "login_form.header",
    defaultMessage: "Sign In",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 56
    }
  }))), /*#__PURE__*/React.createElement(Stack, {
    className: "sm:pt-10 sm:w-2/3 md:w-1/2 mx-auto",
    space: 5,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: handleSubmit,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(FormGroup, {
    labelText: intl.formatMessage(messages.username),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Input, {
    "aria-label": intl.formatMessage(messages.username),
    placeholder: intl.formatMessage(messages.username),
    type: "text",
    name: "username",
    autoCorrect: "off",
    autoCapitalize: "off",
    required: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(FormGroup, {
    labelText: intl.formatMessage(messages.password),
    hintText: /*#__PURE__*/React.createElement(Link, {
      to: "/reset-password",
      className: "hover:underline",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 51,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "login.reset_password_hint",
      defaultMessage: "Trouble logging in?",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 52,
        columnNumber: 17
      }
    })),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Input, {
    "aria-label": intl.formatMessage(messages.password),
    placeholder: intl.formatMessage(messages.password),
    type: "password",
    name: "password",
    autoComplete: "off",
    autoCorrect: "off",
    autoCapitalize: "off",
    required: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(FormActions, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "primary",
    type: "submit",
    disabled: isLoading,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "login.sign_in",
    defaultMessage: "Sign in",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 15
    }
  })))), /*#__PURE__*/React.createElement(ConsumersList, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 9
    }
  })));
};

export default LoginForm;